import React from 'react';
import {Route, Switch, BrowserRouter as Router, Redirect} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'font-awesome/css/font-awesome.min.css'
import './styles.scss';
import {Home} from "./modules/Home";
import {Login} from "./modules/Login";
import {Register} from "./modules/Register";
import {isLogged, getCurrentUser, logOut, AppVersion, topWersja} from "./utilities/Utilities";
import {UserPanel} from "./modules/UserPanel";
import {Statute} from "./modules/Statute";
import {LostPassword} from "./modules/LostPassword";
import axios from 'axios'
import {NotificationContainer} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import {Aktywacja} from "./modules/Aktywacja";
import {NewPassword} from "./modules/NewPassword";
import Instrukcje from "./modules/Instrukcje";
import OrlenPaczka from "./components/OrlenPaczka";
import UsunKonto from "./modules/UsunKonto";
import AktywacjaV2 from "./modules/AktywacjaV2";
import NewPasswordNew from "./modules/NewPasswordNew";
import NewPasswordOld from "./modules/NewPasswordOld";
import KartyProfity from "./modules/KartyProfity";
import KartyProfityWebView from "./modules/KartyProfityWebView";
import InpostPaczka from "./components/InpostPaczka";
import {notify, obslugaEscape} from "./utilities/notify";
import {FokusPoNawigacji} from "./components/a11y/FokusPoNawigacji";

axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.put['Content-Type'] = 'application/json';

axios.defaults.headers.common["Top-Platform"] = "web";
axios.defaults.headers.common["Top-System"] = navigator.userAgent;
axios.defaults.headers.common["Top-Wersja"] = topWersja();
axios.defaults.headers.common["Top-Kraj"] = 'PL';

document.addEventListener('keydown', obslugaEscape);

if (isLogged()) {
    if (getCurrentUser().token)
        if (getCurrentUser().token.indexOf('Basic') > -1) {
            axios.defaults.headers.common.Authorization = getCurrentUser().token;
            //OfertaService.updateSieciHandloweInLS(LoginService.getCurrentUser().kontos);
            //localStorage.setItem(localStorageTypes.CURRENT_CZY_ODCZYTANO_POWIADOMIENIA,"true")
        } else {
            axios.defaults.headers.common.Authorization = '';
            logOut();
        }
}


axios.interceptors.request.use(function (config) {
    document.body.classList.add('loading-indicator');
    return config
}, function (error) {
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    setTimeout(() => {
        document.body.classList.remove('loading-indicator');
    }, 330);
    return response;
}, function (error) {
    setTimeout(() => {
        document.body.classList.remove('loading-indicator');
    }, 330);
    if (!error.response) {
        notify.error('Brak komunikacji z serwerem', 'Wystąpił błąd podczas działania aplikacji');
        return Promise.reject(error);
    }
    if (error.response.request.responseType === 'blob') {
        console.log('BLOB')
    } else {
        console.log(error.response);
        console.log(error.response.data.message)
        if (!Boolean(error.response.data.message)) {
            notify.error('Kod błędu ' + error.response.status + ', error: ' + error.response.statusText, 'Wystąpił błąd podczas działania aplikacji');
        } else if (error.response.data.message === "User is disabled") {
            notify.error("Aktywuj konto przez link zamieszczony w wysłanej wiadomości e-mail", 'Konto jest nieaktywne');
        } else if (error.response.data.message === "Bad credentials") {
            notify.error("", 'Niepoprawne dane logowania');
        }
        return Promise.reject(error);
    }
});

function App() {
    return (
        <Router>
            <NotificationContainer/>
            <FokusPoNawigacji/>
            <Switch>
                <Route exact path={'/'} component={Home}/>
                <Route exact path={'/konto/aktywuj/:email/:token'} render={(props) => <Aktywacja {...props} />}/>
                <Route exact path={'/konto/v2/aktywuj/:email/:token'} render={(props) => <AktywacjaV2 {...props} />}/>
                <Route exact path={'/konto/usunKonto/:email/:token'} render={(props) => <UsunKonto {...props} />}/>
                <Route exact path={'/new-password/:token'} render={(props) => <NewPasswordOld {...props} />}/>
                <Route exact path={'/new-password/:email/:token'} render={(props) => <NewPassword {...props} />}/>
                <Route exact path={'/konto/v2/new-password/:email/:token'} render={(props) => <NewPasswordNew {...props} />}/>
                <Route path={'/login'} component={Login}/>
                <Route path={'/lost-password'} component={LostPassword}/>
                <Route exact path={'/register'} component={Register}/>
                <Route path={'/register/:migracja'} render={(props) => <Register {...props} />}/>
                <Route path={'/regulamin'} component={Statute}/>
                <Route path={'/instrukcje'} component={Instrukcje}/>
                <Route path={'/orlenpaczka'} component={OrlenPaczka}/>
                <Route path={'/inpost'} component={InpostPaczka}/>
                <Route path={'/konto'} render={isLogged() ? () => <UserPanel active={1}/> : () => <Login/>}/>
                <Route path={'/karta'} render={isLogged() ? () => <UserPanel active={2}/> : () => <Login/>}/>
                <Route path={'/kartyProfity'} component={KartyProfity}/>
                <Route path={'/kartyProfityWebView'} component={KartyProfityWebView}/>
                <Route path={'/reklamacje'} render={isLogged() ? () => <UserPanel active={3}/> : () => <Login/>}/>
                <Route path={'/twojsklep'} render={isLogged() ? () => <UserPanel active={5}/> : () => <Login/>}/>
                <Redirect to={'/'}/>
            </Switch>
        </Router>
    );
}

export default App;
